import { Spinner } from 'reactstrap';

// This just existing to be similar to the FullPageSpinner
const LargeSpinner = (): JSX.Element => (
    <Spinner style={{ height: '5rem', width: '5rem' }} />
);

export default LargeSpinner;
